import React from 'react';
import { UnstyledButton } from '@/components/ui/Buttons';
import I18n from 'i18n-js';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import cn from '@/utils/cn';

const EndSessionButton = () => {
  const openEndSessionModal = useSlideShowContext(state => state.openEndSessionModal);
  const userType = useSlideShowContext(state => state.userType);

  const buttonText = userType === 'Student' ? I18n.t('leave_session') : I18n.t('end_session');

  return (
    <UnstyledButton
      aria-label={buttonText}
      className={cn('tw-rounded tw-p-2 tw-whitespace-nowrap tw-cursor-pointer tw-font-tci', {
        'tw-bg-red tw-text-white tw-border-white tw-border-[1px] tw-border-solid': userType !== 'Student',
        'tw-hidden': userType === 'Student',
      })}
      type="button"
      onClick={userType !== 'Student' ? openEndSessionModal : () => {}}
    >
      {buttonText}
    </UnstyledButton>
  );
};

export default EndSessionButton;
